import React from 'react';
import './podcastSection.scss';
import '../pages/index.scss';
import PodcastCard from './PodcastCard';
import { graphql, useStaticQuery } from 'gatsby';
import { StrapiFeatured } from '../data/StrapiFeatured';

interface Props {}

const PodcastSection: React.FC<Props> = () => {
  const podcasts: StrapiFeatured = useStaticQuery(
    graphql`
      {
        allStrapiFeatured {
          edges {
            node {
              podcasts {
                podcastUrl
                title
                description
                speakers {
                  twitterHandle
                  linkedInUrl
                  description
                  name
                  profileImage {
                    childImageSharp {
                      fluid(maxWidth: 200, maxHeight: 200) {
                        ...GatsbyImageSharpFluid
                      }
                    }
                  }
                }
              }
            }
          }
        }
        allStrapiHomePage {
          edges {
            node {
              podcastCopyText
            }
          }
        }
      }
    `,
  );

  const {
    podcastUrl,
    description,
    speakers,
  } = podcasts.allStrapiFeatured.edges[0].node.podcasts[0];
  const {
    name,
    description: descriptionSpeaker,
    profileImage,
    linkedInUrl,
    twitterHandle,
  } = speakers[0];

  return (
    <div className="podcastSectionContainer">
      <h2 className="alignCenter">Featured Podcast</h2>
      <p>{podcasts.allStrapiHomePage.edges[0].node.podcastCopyText}</p>
      <PodcastCard
        name={name}
        title={descriptionSpeaker}
        description={description}
        podcastUrl={podcastUrl}
        profileImageUrl={profileImage.childImageSharp.fluid}
        twitterUrl={twitterHandle}
        linkedInUrl={linkedInUrl}
      />
    </div>
  );
};
export default PodcastSection;
